import { FC } from "react";
import { MiSearchAutocomplete } from "@miplatform/components";
import { buildSearchQuery } from "@miplatform/utils";
import { useOrders } from "@mibuildweb/hooks";
import { OrdersSearchOptionItem } from "../OrderSearch.types";
import { OrderSearchOption } from "./OrderSearchOption";

export const OrdersAutocompleteSearch: FC<OrdersAutocompleteSearchProps> = ({
  search,
  debouncedSearch,
  onSearchChange,
  onEnterPress,
}) => {
  const { getOrders, isLoading, orders } = useOrders();

  const orderOptions: OrdersSearchOptionItem[] =
    orders?.map((order) => ({
      label: order.home.address.addressLine1,
      value: order.id,
      ...order,
    })) || [];

  const handleGetOrderOptions = async () => {
    const searchQuery = buildSearchQuery(search, ["home/address/addressLine1"]);

    await getOrders({
      filters: { ...searchQuery },
      sort: "home/address/addressLine1 asc",
      top: 10,
    });
  };

  const handleClearSearchInput = () => {
    onSearchChange("");
  };

  return (
    <MiSearchAutocomplete
      label="Orders Search"
      placeholder="Search by Order Number, Home Address, Customer Name, etc."
      search={search}
      debouncedSearch={debouncedSearch}
      onSearchChange={onSearchChange}
      onEnterPress={onEnterPress}
      onClearSearch={handleClearSearchInput}
      options={orderOptions}
      getOptions={handleGetOrderOptions}
      loading={isLoading}
      width="30%"
      renderOption={(props, option: OrdersSearchOptionItem) => (
        <OrderSearchOption option={option} props={props} close={() => {}} />
      )}
    />
  );
};

interface OrdersAutocompleteSearchProps {
  search: string;
  debouncedSearch: string;
  onSearchChange: (value: string) => void;
  onEnterPress?: () => void;
}
